import api from '../axiosInstance';

export async function getRuntimeConfig(signal) {
  const response = await api.get('/api/config/runtime', { signal });
  return response.data;
}
